import React from 'react';
import { Alert, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

const { Text } = Typography;

const MaintenanceBanner: React.FC = () => {
    return (
        <div style={{ width: 'fit-content' }}>
            <Alert
                icon={<ToolOutlined style={{ fontSize: 24, color: '#faad14' }} />}
                type="warning"
                showIcon
                message={
                    <Text strong style={{ fontSize: 18 }}>
                        Раздел находится на обновлении
                    </Text>
                }
                description={
                    <div style={{ marginTop: 8 }}>
                        <Text style={{ fontSize: 14 }}>
                            Данный раздел временно недоступен в связи с проведением технических работ.
                            Он станет доступен на старте приёмной кампании 2026 года.
                        </Text>
                    </div>
                }
                style={{
                    margin: '24px 0',
                    borderRadius: 8,
                }}
            />
        </div>
    );
};

export default MaintenanceBanner;
